/**
 * <availability-toggle>
 *
 * Renders the Stock / Pre-order buttons in the price area. It owns no variant
 * logic of its own: a click simply checks the matching radio inside the hidden
 * Availability option of <variant-picker> and fires a change event. The theme's
 * existing variant-picker pipeline then re-fetches the variant and re-renders
 * the price, countdown, add-to-cart button and this toggle (all of which are
 * tagged data-dynamic-variant-content), keeping everything in sync.
 */
if (!customElements.get('availability-toggle')) {
  class AvailabilityToggle extends HTMLElement {
    connectedCallback() {
      this.boundHandleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.boundHandleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundHandleClick);
    }

    handleClick(evt) {
      const btn = evt.target.closest('[data-availability-value]');
      if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-checked') === 'true') return;
      evt.preventDefault();

      const value = btn.dataset.availabilityValue;
      const optionName = (this.dataset.optionName || '').toLowerCase();

      const scope = this.closest('.shopify-section, .js-quickbuy, .cc-featured-product') || document;
      const picker = scope.querySelector('variant-picker');
      if (!picker) return;

      const selector = Array.from(picker.querySelectorAll('.option-selector'))
        .find((s) => (s.dataset.option || '').toLowerCase() === optionName);
      if (!selector) return;

      // Listed (radio) selector — the hidden Availability option uses this.
      const input = selector.querySelector(`input.js-option[value="${CSS.escape(value)}"]`);
      if (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Dropdown fallback, in case the option is ever rendered as a custom-select.
      const opt = selector.querySelector(`.custom-select__option[data-value="${CSS.escape(value)}"]`);
      const customSelect = opt && opt.closest('custom-select');
      if (customSelect) customSelect.selectOption(opt);
    }
  }

  customElements.define('availability-toggle', AvailabilityToggle);
}
